import React from 'react'

interface IAiSparkleIconProps {
  size?: number
  color?: string
  style?: React.CSSProperties
}

export default function AiSparkleIcon({ size = 16, color = 'currentColor', style }: IAiSparkleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0,0,256,256"
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <g fill={color} fillRule="nonzero" stroke="none">
        <g transform="scale(5.12,5.12)">
          <path d="M22.462,11.035l2.88,7.097c1.204,2.968 3.558,5.322 6.526,6.526l7.097,2.88c1.312,0.533 1.312,2.391 0,2.923l-7.097,2.88c-2.968,1.204 -5.322,3.558 -6.526,6.526l-2.88,7.097c-0.533,1.312 -2.391,1.312 -2.923,0l-2.88,-7.097c-1.204,-2.968 -3.558,-5.322 -6.526,-6.526l-7.097,-2.88c-1.312,-0.533 -1.312,-2.391 0,-2.923l7.097,-2.88c2.968,-1.204 5.322,-3.558 6.526,-6.526l2.88,-7.097c0.532,-1.312 2.39,-1.312 2.923,0zM39.945,2.701l0.842,2.428c0.664,1.915 2.169,3.42 4.084,4.084l2.428,0.842c0.896,0.311 0.896,1.578 0,1.889l-2.428,0.842c-1.915,0.664 -3.42,2.169 -4.084,4.084l-0.842,2.428c-0.311,0.896 -1.578,0.896 -1.889,0l-0.842,-2.428c-0.664,-1.915 -2.169,-3.42 -4.084,-4.084l-2.428,-0.842c-0.896,-0.311 -0.896,-1.578 0,-1.889l2.428,-0.842c1.915,-0.664 3.42,-2.169 4.084,-4.084l0.842,-2.428c0.31,-0.896 1.578,-0.896 1.889,0z" />
        </g>
      </g>
    </svg>
  )
}
